import React, { Component } from 'react';
import Button from '../../components/Button';
import CompanyItem from '../CompanyItem';
import SocialList from '../SocialList';
import WorkerCard from '../WorkerCard';
import { connect } from 'react-redux';
import './VacancyCard.css';
import { HOST } from '../../constants/Fetch'
import Preloader from '../Preloader';
import ErrorMessage from '../ErrorMessage';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { loadCompany } from '../../actions/CompanyActions';

const phoneRegEx = /[\s()-]/g;

const TagList = props => {
    const { city, city: { id, name } = {}, employments, experience, scope_activities, vacancyName } = props;

    const isInternshipPage = /^\/internships\/internship\d+\/?$/.test(window.location.pathname);

    let buttonLink = '#toVacancyForm';

    if (isInternshipPage) {
        if (vacancyName && vacancyName.indexOf('Стажировка') !== -1) {
            buttonLink = 'https://start.rabotaertelecom.ru/internship';
        } else if (vacancyName && vacancyName.indexOf('Практика') !== -1) {
            buttonLink = 'https://start.rabotaertelecom.ru/practice';
        }
    }

    const handleButtonClick = e => {
        if (buttonLink.indexOf('http') === 0) {
            e.preventDefault();
            window.location.href = buttonLink;
        }
    };

    return (
        <div className="vacancyCard__tags">
            {
                city &&
                <div className="vacancyCard__tagItem" key={`vacancyCard__tag-${id}`}>{name}</div>
            }
            {
                employments &&
                employments.map((employment, index) => (
                    <div className="vacancyCard__tagItem" key={`vacancyCard__tag-${index}`}>{employment.name}</div>
                ))
            }
            {
                experience &&
                experience.map((exp, index) => (
                    <div className="vacancyCard__tagItem" key={`vacancyCard__tag-${index}`}>{exp.name}</div>
                ))
            }
            {
                scope_activities &&
                scope_activities.map((activity, index) => (
                    <div className="vacancyCard__tagItem" key={`vacancyCard__tag-${index}`}>{activity.name}</div>
                ))
            }

            <div className="vacancyCard__button" onClick={handleButtonClick}>
                <Button
                    smooth={buttonLink === '#toVacancyForm'}
                    link={buttonLink === '#toVacancyForm' ? '#toVacancyForm' : '#'}
                    class="goal101"
                    text="Откликнуться"
                    modifier="button--xs"
                />
            </div>
        </div>
    );
};

const ContactPerson = props => (
  <div className="vacancyCard__contactPerson">
    {
      props.person.image && <img className="vacancyCard__contactPhoto" src={HOST + props.person.image} alt={props.person.last_name} />
    }
    <div className="vacancyCard__contactTitle">Контактное лицо</div>
    <div className="vacancyCard__contactName">{props.person.first_name} {props.person.last_name}</div>
    {
      props.person.phone &&
      <a className="vacancyCard__contactInfo" href={`tel:${props.person.phone.replace(phoneRegEx, "")}`}>
                {/*props.person.phone*/} {/* Городской номер 324 из Админки */}
        {/*props.person.personal_phone && ` (доб. ${props.person.personal_phone})` */} {/* Персональный номер рекрутёра из БД */}
                {/*props.person.personal_phone*/}
                {props.person.personal_phone ? props.person.personal_phone : props.person.phone}
      </a>
    }
    {
      props.person.email &&
      <a className="vacancyCard__contactInfo" href={`mailto:${props.person.email}`}>{props.person.email}</a>
    }
  </div>
)

class VacancyCard extends Component {
  static contextTypes = {
    width: PropTypes.number
  };

  checkAllowCompany() {
    const allowedCompanies = ['ЭР-Телеком', 'Дом.ru', 'Дом.ru Бизнес'];
    
    if(this.props.vacancy.company &&
      allowedCompanies.find(el => el === this.props.vacancy.company.name)
    ) {
      return true
    }

    return false
  }

  isAllowedCompany = this.checkAllowCompany()

  componentDidMount(){
    !this.isAllowedCompany && this.props.actions.loadCompany(20);
  }

  render() {
    const vacancy = this.props.vacancy;
      window.vacancyName = vacancy.name;
    if (this.props.hasErrored) {
      return <ErrorMessage/>;
    }

    if (this.props.isLoading) {
       return <Preloader/>;
    }
    return (
      [
        <div className="container  container--indentVertical" key="vacancyCard_top">
          <div className="vacancyCard row">
            <div className="col col--9 vacancyCard__col colVertTablet--12">
                {
                    !(vacancy.company === undefined) &&
                    <div>
                        {
                            this.context.width <= 800 && vacancy.company.logo &&
                            <img
                                className="vacancyCard__itemLogo"
                                src={HOST + vacancy.company.logo}
                                alt={vacancy.company.name}
                            />
                        }

                        <div className="vacancyCard__itemCompany">
                            {vacancy.company.name}
                        </div>
                    </div>
                }
              <h1 className="text text--h1 vacancyCard__title">{vacancy.name}</h1>
              {
                (vacancy.city || vacancy.employment || vacancy.experience || vacancy.scope_activity) &&
                <TagList city={vacancy.city} employments={vacancy.employment} experience={vacancy.experience} scope_activities={vacancy.scope_activity} vacancyName={vacancy.name} />
              }
              {
                this.context.width <= 800 &&
                <div className="text text--bottom24">
                  <SocialList url={HOST + this.props.match.url} title={vacancy.name} />
                </div>
              }
              <div className="text text--bottom24" dangerouslySetInnerHTML={{ __html: vacancy.content}} />
            </div>
            <div className="col col--3 vacancyCard__col colVertTablet--12">
              {
                (this.context.width > 800 && !(vacancy.company === undefined)) &&
                <CompanyItem
                  modifier={this.colModifier}
                  card={ this.isAllowedCompany ? vacancy.company : this.props.company}
                  inVacancy={true}
                />
              }
              {
                (this.context.width > 800 && !(vacancy.contact_person === undefined)) &&
                <React.Fragment>
                  {
                    vacancy.contact_person &&
                    <ContactPerson person={vacancy.contact_person} isInternship={this.props.isInternship} />
                  }
                  <SocialList url={HOST + this.props.match.url} title={vacancy.name} />
                </React.Fragment>
              }
            </div>
          </div>
        </div>,
        <div className="container container--noPaddinngVertTablet" key="vacancyCard_middle">
          {
            (!(vacancy.history_success === undefined) && vacancy.history_success) &&
            <div className="col col--12 vacancyCard__col vacancyCard__col--worker">
              <WorkerCard inVacancy={true} worker={vacancy.history_success} position={vacancy.name} />
            </div>
          }
        </div>,
        (this.context.width <= 800  && !(vacancy.contact_person === undefined)) &&
        <div className="container container--indentVertical">
          <ContactPerson person={vacancy.contact_person} isInternship={this.props.isInternship} />
        </div>
      ]
    );
  }
}

const mapStateToProps = (state) => {
  return {
      company: state.company.item,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadCompany }, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VacancyCard);




// WEBPACK FOOTER //
// ./src/components/VacancyCard/index.js